import storageAvailable from 'storage-available';
import {doAjax} from 'surveylabJsAssets/common/_ajax';
import SentryHelper from 'surveylabJsAssets/sentry/_sentry-helper';
import {SeverityLevel} from "@sentry/browser";
import {Modal} from "bootstrap";
import AssessmentHelper from '../common/_assessment-helper';

// noinspection JSUnusedGlobalSymbols
export default function () {

    // Wait until images are loaded as well, see http://stackoverflow.com/a/545005/94289
    $(window).on("load", function () {
        // Constants
        const MAX_LOGGING_ATTEMPTS = 10;

        // Initialize
        const pageReady = Date.now();
        const modulePageIndex = parseInt(<string>$('#module-page-index').val(), 10);
        const pageType = $('#page-type').val(); // 'instruction' or 'test'
        const timeLimit = Number($('#time-limit').val());
        const isTestPage = pageType == 'test';
        const isInstructionPage = !isTestPage;
        let timeIsRunning = isTestPage;
        let elapsedTime = 0;
        let storedElapsedTime = 0;
        let pauseStart: number = null;
        let pauseDuration = 0; // Sum of durations where the no-answer warning is displayed
        let loggingWaiting = false; // An ajax log request is underway
        let loggingSuccess = false; // Ajax log request successful

        // Elements
        const $submitButton = $('#next-button');

        if (!storageAvailable('localStorage')) {
            $submitButton.addClass('disabled').attr('disabled', 'disabled');
            $('#localstorage-warning').removeClass('d-none');
            throw new Error("Trying to use BRTA without local storage enabled.");
        }

        // Reset timing on first (instruction) page of the module.
        if (modulePageIndex == 0) {
            localStorage.removeItem("lastNextClick");
            localStorage.removeItem("storedElapsedTime");
        }
        // Read stored elapsed time
        if (isTestPage && localStorage.getItem("storedElapsedTime") !== null) {
            storedElapsedTime = parseInt(localStorage.getItem("storedElapsedTime"), 10);
            elapsedTime = storedElapsedTime;
        }
        const lastNextClick = localStorage.getItem("lastNextClick") !== null ? parseInt(localStorage.getItem("lastNextClick"), 10) : null;

        let noAnswerConfirmed = false;

        // The item is hidden until fully loaded
        $('.survey-item').removeClass('d-none');

        // Display no-answer warning, or log timing entry for page (item)
        $submitButton.on('click', function (event) {
            if (loggingSuccess) {
                return; // Form will be submitted
            } else {
                event.preventDefault(); // Don't submit form
            }
            if (loggingWaiting || (isInstructionPage && !AssessmentHelper.isCorrectAnswer())) {
                return;
            }

            timeIsRunning = false;
            if (!noAnswerConfirmed && !hasAnswer() && isTestPage) {
                startPause();
                noAnswerModal.show();
            } else {
                stopPause(false);
                const nextClick = Date.now();

                localStorage.setItem("lastNextClick", nextClick.toString());
                localStorage.setItem("storedElapsedTime", elapsedTime.toString());

                logTimingEntry(nextClick);
            }
        });

        // Handle events for the no-answer modal
        const $noAnswerModal = $('#no-answer-modal');
        const noAnswerModal = new Modal('#no-answer-modal', {backdrop: 'static'});
        $('.confirm-btn', $noAnswerModal).on('click', function (e) {
            e.preventDefault();
            noAnswerConfirmed = true;
            $submitButton.trigger('click');
        });

        $noAnswerModal.on('hide.bs.modal', function () {
            stopPause(true);
        });

        $noAnswerModal.on('show.bs.modal hidden.bs.modal', function () {
            $('body').toggleClass('no-answer-modal-open');
        });

        // Loop for updating and displaying elapsed time and checking time limit
        // see http://stackoverflow.com/a/6685414/94289
        const $timeOverModal = $('#time-over-modal');
        const timeOverModal = new Modal('#time-over-modal', {backdrop: 'static'});
        (function updateElapsedTime() {
            if (isTestPage) {
                setTimeout(updateElapsedTime, 100);
                if (timeIsRunning) {
                    elapsedTime = getElapsedTime();
                    displayTime(elapsedTime);
                    if (elapsedTime >= timeLimit) {
                        timeIsRunning = false;
                        timeOverModal.show();
                    }
                    localStorage.setItem("storedElapsedTime", elapsedTime.toString());
                }
            }
        })();

        $timeOverModal.on('show.bs.modal hidden.bs.modal', function () {
            $('body').toggleClass('time-over-modal-open');
        });

        function logTimingEntry(nextClick: number): void {
            loggingWaiting = true;

            const pageID = $("input[name='hidden-page-id']").val();
            const userSurveyID = $("input[name='hidden-user-survey-id']").val();
            const loadDuration = lastNextClick ? pageReady - lastNextClick : 0;
            let itemDuration = nextClick - pageReady - pauseDuration; // Active time the user spent on the item
            if (itemDuration < 0) {
                SentryHelper.log(
                    'Item duration is negative, which indicates the timing is not working properly on client side. Proceeding with 0.',
                    <SeverityLevel>'error',
                    {
                        pageID: pageID,
                        userSurveyID: userSurveyID,
                        pageReady: pageReady,
                        nextClick: nextClick,
                        loadDuration: loadDuration,
                        itemDuration: itemDuration,
                        pauseDuration: pauseDuration,
                        elapsedTime: elapsedTime
                    }
                );
                itemDuration = 0;
            }

            const timingEntry = {
                'pageID': pageID,
                'userSurveyID': userSurveyID,
                'pageReady': pageReady,
                'nextClick': nextClick,
                'loadDuration': loadDuration,
                'itemDuration': itemDuration,
                'pauseDuration': pauseDuration,
                'elapsedTime': elapsedTime
            };
            const ajaxRequest = {
                url: <string>$('#log-timing-entry-url').val(),
                type: "POST",
                dataType: "json",
                timeout: 5000,
                data: timingEntry
            };

            const jqXHR = doAjax(ajaxRequest, MAX_LOGGING_ATTEMPTS);
            jqXHR.done(function () {
                loggingSuccess = true;
                $submitButton.trigger('click');
            });
        }

        /**
         * Check if the timing is paused at the moment.
         */
        function isPause(): boolean {
            return pauseStart !== null;
        }

        /**
         * Start pause
         */
        function startPause(): void {
            if (!isPause()) {
                pauseStart = Date.now();
                timeIsRunning = false;
            }
        }

        /**
         * Stop pause and update pause duration.
         */
        function stopPause(resumeTiming: boolean): void {
            if (isPause()) {
                pauseDuration += Date.now() - pauseStart;
                pauseStart = null;
                if (resumeTiming) {
                    timeIsRunning = true;
                }
            }
        }

        /**
         * Displays the elapsed time.
         *
         * @param {number} elapsedTime In milliseconds
         */
        function displayTime(elapsedTime: number): void {
            $('#module-time').text(getDisplayTime(elapsedTime));
        }

        /**
         * Returns the current elapsed time in milliseconds.
         */
        function getElapsedTime(): number {
            return Math.min(storedElapsedTime + (Date.now() - pageReady - pauseDuration), timeLimit);
        }

        /**
         * Returns the time as string displayed to the user (format m:ss).
         */
        function getDisplayTime(elapsedTime: number): string {
            const remainingTime = Math.max(timeLimit - elapsedTime, 0);
            const minutes = Math.floor(remainingTime / 60000);
            const seconds = Math.floor((remainingTime % 60000) / 1000);

            return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
        }

        function hasAnswer(): boolean {
            return $('.survey-item input:checked').val() !== undefined;
        }
    });
}
